import React from 'react'
import './Footer.css';
function footer() {
  return (
    <div className='footer'>
        <footer>
            <div className='footer-container'>
            <span>SPACEX &copy; 2023</span>
                <span>PRIVACY POLICY</span>
                <span>SUPPLIERS</span>
            </div>
        </footer>
    </div>
  )
}

export default footer;